var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUplinkIcon600(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 29 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M47.288 32.247h28.053v26.006H47.288z",
    transform: "translate(-47.288 -32.247)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.977 8.763c-2.194 0-4 1.805-4 4 0 .5.1 1 .28 1.46l-.88 2.4a6.026 6.026 0 0 1-1.4-3.86c0-3.292 2.708-6 6-6 3.291 0 6 2.708 6 6 0 1.47-.53 2.81-1.4 3.86l-.88-2.4c.18-.46.28-.96.28-1.46 0-2.195-1.806-4-4-4m0-4c-4.389 0-8 3.611-8 8 0 2.36 1 4.5 2.64 5.94l-.72 2a10.005 10.005 0 0 1-3.92-7.94c0-5.486 4.514-10 10-10s10 4.514 10 10c0 3.23-1.54 6.11-3.92 7.94l-.72-2c1.64-1.44 2.64-3.58 2.64-5.94 0-4.389-3.611-8-8-8Z",
    style: {
      fill: "#4f46e5",
      fillRule: "nonzero"
    },
    transform: "translate(-2.773 -3.589) scale(1.40263)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 4c2.194 0 4 1.806 4 4s-1.806 4-4 4-4-1.806-4-4 1.806-4 4-4",
    style: {
      fill: "#4f46e5",
      fillRule: "nonzero"
    },
    transform: "translate(4.976 8.217) scale(.7542)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14c4.42 0 8 1.79 8 4v2H4v-2c0-2.21 3.58-4 8-4Z",
    style: {
      fill: "#4f46e5",
      fillRule: "nonzero"
    },
    transform: "translate(6.426 12.782) scale(.63336)"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUplinkIcon600);
export default __webpack_public_path__ + "static/media/uplink-icon-600.d4764b577fe2f5ca5470cffa054133be.svg";
export { ForwardRef as ReactComponent };